// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   FlowBuilder - Typebot-like Sidebar + Premium UI
   ========================================================= */

/* Canvas */
.flow-canvas-container {
  background-color: #f3f4f6;
  background-image: radial-gradient(#d1d5db 1px, transparent 1px);
  background-size: 22px 22px;
  width: 100%;
  height: 100%;
  flex: 1 1;
  min-width: 0;
}

/* React Flow - controls/minimap */
.react-flow__controls {
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.react-flow__controls-button {
  background: #ffffff;
  border: none;
  color: #111827;
}

.react-flow__controls-button:hover {
  background: #f9fafb;
}

.react-flow__minimap {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
}

.react-flow__node.selected > div {
  outline: 2px solid rgba(99, 102, 241, 0.28);
  outline-offset: 2px;
}

/* =========================================================
   Sidebar (Typebot-like)
   ========================================================= */
.flowbuilder-sidebar {
  /* Align full height with the flow canvas */
  position: relative;
  top: 0;
  align-self: stretch;
  height: 100%;
  max-height: none;
  overflow: auto;

  width: 300px;
  flex: 0 0 300px;

  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(17, 24, 39, 0.08);
  border-radius: 16px;
  box-shadow: 0 14px 40px rgba(16, 24, 40, 0.10);

  padding: 12px;

  font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto,
    Arial, "Noto Sans", "Liberation Sans", sans-serif;
}

.flowbuilder-sidebar::-webkit-scrollbar { width: 10px; }
.flowbuilder-sidebar::-webkit-scrollbar-thumb {
  background: rgba(15, 23, 42, 0.10);
  border-radius: 999px;
  border: 3px solid transparent;
  background-clip: content-box;
}
.flowbuilder-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(15, 23, 42, 0.18);
  border: 3px solid transparent;
  background-clip: content-box;
}

/* Top: Search + lock */
.flowbuilder-sidebar__top{
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}

.flowbuilder-sidebar__search{
  flex: 1 1;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(17, 24, 39, 0.10);
  background: #ffffff;
  padding: 0 12px;
  outline: none;
  font-size: 13px;
  color: #0f172a;
}

.flowbuilder-sidebar__search::placeholder{
  color: rgba(15, 23, 42, 0.45);
}

.flowbuilder-sidebar__search:focus{
  border-color: rgba(99, 102, 241, 0.35);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.flowbuilder-sidebar__lock{
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(17, 24, 39, 0.10);
  background: #ffffff;
  color: rgba(15, 23, 42, 0.55);
  cursor: not-allowed;
}

/* Sections */
.flowbuilder-sidebar__section{
  margin-bottom: 12px;
}

.flowbuilder-sidebar__title {
  font-size: 12px;
  font-weight: 600; /* lighter than before */
  letter-spacing: 0.02em;
  color: rgba(15, 23, 42, 0.55);
  margin: 6px 6px 8px;
}

/* Grid of chips (Typebot-like) */
.flowbuilder-sidebar__grid{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 0 2px;
}

.flowbuilder-sidebar__chip{
  display: flex;
  align-items: center;
  gap: 8px;

  height: 38px;
  padding: 0 10px;

  border-radius: 12px;
  background: #ffffff;
  border: 1px solid rgba(17, 24, 39, 0.10);

  color: #0f172a;
  cursor: pointer;
  text-align: left;

  transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease;
}

.flowbuilder-sidebar__chip:hover{
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(16, 24, 40, 0.10);
  border-color: rgba(99, 102, 241, 0.28);
}

.flowbuilder-sidebar__chip:disabled{
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.flowbuilder-sidebar__chipIcon{
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
}

.flowbuilder-sidebar__chipLabel{
  font-size: 13px;
  font-weight: 500; /* no bold */
  line-height: 1;
  color: rgba(15, 23, 42, 0.85);
}

/* Hide on small screens */
@media (max-width: 980px) {
  .flowbuilder-sidebar {
    display: none;
  }
}

/* =========================================================
   Nodes (Premium) - used by message/menu/openai nodes
   ========================================================= */
.fb-node{
  width: 250px;
  position: relative;

  background: rgba(255,255,255,0.96);
  border: 1px solid rgba(17, 24, 39, 0.10);
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(16, 24, 40, 0.10);

  padding: 12px;
  transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease;

  font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto,
    Arial, "Noto Sans", "Liberation Sans", sans-serif;
}

.fb-node:hover{
  transform: translateY(-1px);
  box-shadow: 0 18px 46px rgba(16, 24, 40, 0.14);
  border-color: rgba(99, 102, 241, 0.28);
}

.react-flow__node.selected .fb-node{
  outline: 2px solid rgba(99, 102, 241, 0.28);
  outline-offset: 2px;
}

.fb-node__header{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 56px;
  margin-bottom: 8px;
}

.fb-node__chip{
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 999px;

  background: rgba(99, 102, 241, 0.10);
  border: 1px solid rgba(99, 102, 241, 0.18);
  color: #0f172a;
  font-size: 13px;
  font-weight: 600; /* lighter */
}

.fb-node__body{
  color: rgba(15, 23, 42, 0.75);
  font-size: 12.5px;
  line-height: 1.35;
  padding-right: 6px;
}

/* Actions (top-right) */
.fb-node__actions{
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  gap: 6px;
}

.fb-iconbtn{
  width: 30px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid rgba(17, 24, 39, 0.08);
  background: rgba(255,255,255,0.92);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(15, 23, 42, 0.55);
  transition: background 120ms ease, transform 120ms ease, color 120ms ease,
    border-color 120ms ease;
}

.fb-iconbtn:hover{
  background: #ffffff;
  color: rgba(15, 23, 42, 0.80);
  border-color: rgba(99, 102, 241, 0.22);
  transform: translateY(-1px);
}

/* Handles */
.fb-handle{
  width: 18px !important;
  height: 18px !important;
  border-radius: 999px !important;
  background: #6366F1 !important;
  border: 2px solid #ffffff !important;
  box-shadow: 0 10px 22px rgba(99, 102, 241, 0.28);
  cursor: pointer;
}

.fb-handle__arrow{
  color: #ffffff;
  width: 10px;
  height: 10px;
  margin-left: 4px;
  margin-bottom: 1px;
  pointer-events: none;
}


/* =========================================================
   Workspace alignment (Sidebar + Canvas)
   ========================================================= */
.fb-workspace{
  align-items: stretch;
  gap: 14px;
}

/* Ensure canvas and sidebar share the same vertical span */
.flow-canvas-container{
  border-radius: 16px;
  border: 1px solid rgba(17, 24, 39, 0.06);
  box-shadow: 0 14px 40px rgba(16, 24, 40, 0.06);
  overflow: hidden;
}

/* =========================================================
   Header polish (Title + Buttons)
   ========================================================= */
.fb-headerbar{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 18px;
}

.fb-header-left{
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.fb-header-left > *:first-child{
  /* Title component */
  margin: 0;
}

.fb-header-subtitle{
  font-size: 12.5px;
  font-weight: 400;
  color: rgba(15, 23, 42, 0.62);
}

.fb-header-actions{
  display: flex;
  gap: 10px;
}

/* Buttons (Material-UI v4) */
.fb-header-btn{
  border-radius: 12px !important;
  padding: 8px 14px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  box-shadow: 0 10px 22px rgba(16, 24, 40, 0.10) !important;
  transition: transform 120ms ease, box-shadow 120ms ease, filter 120ms ease !important;
}

.fb-header-btn:hover{
  transform: translateY(-1px);
  box-shadow: 0 14px 30px rgba(16, 24, 40, 0.14) !important;
  filter: brightness(1.02);
}

/* Optional: color accents without changing your theme primary */
.fb-btn-import{ }
.fb-btn-export{ }
.fb-btn-save{ }`, "",{"version":3,"sources":["webpack://./src/pages/FlowBuilderConfig/flowbuilder.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAE9D,WAAW;AACX;EACE,yBAAyB;EACzB,+DAA+D;EAC/D,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,SAAO;EACP,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;8DAE8D;AAC9D;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,MAAM;EACN,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;;EAEd,YAAY;EACZ,eAAe;;EAEf,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,8CAA8C;;EAE9C,aAAa;;EAEb;qDACmD;AACrD;;AAEA,0CAA0C,WAAW,EAAE;AACvD;EACE,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB,EAAE,wBAAwB;EAC1C,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,YAAY;EACZ,eAAe;;EAEf,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;;EAExC,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB,EAAE,YAAY;EAC9B,cAAc;EACd,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;EACf;AACF;;AAEA;;8DAE8D;AAC9D;EACE,YAAY;EACZ,kBAAkB;;EAElB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,8CAA8C;;EAE9C,aAAa;EACb,gFAAgF;;EAEhF;qDACmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;;EAEpB,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,gBAAgB,EAAE,YAAY;AAChC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B;2BACyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,oCAAoC;EACpC,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;;AAGA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;EACnB,wCAAwC;EACxC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;;8DAE8D;AAC9D;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,yDAAyD;EACzD,qFAAqF;AACvF;;AAEA;EACE,2BAA2B;EAC3B,yDAAyD;EACzD,wBAAwB;AAC1B;;AAEA,gEAAgE;AAChE,gBAAgB;AAChB,gBAAgB;AAChB,cAAc","sourcesContent":["/* =========================================================\n   FlowBuilder - Typebot-like Sidebar + Premium UI\n   ========================================================= */\n\n/* Canvas */\n.flow-canvas-container {\n  background-color: #f3f4f6;\n  background-image: radial-gradient(#d1d5db 1px, transparent 1px);\n  background-size: 22px 22px;\n  width: 100%;\n  height: 100%;\n  flex: 1;\n  min-width: 0;\n}\n\n/* React Flow - controls/minimap */\n.react-flow__controls {\n  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.react-flow__controls-button {\n  background: #ffffff;\n  border: none;\n  color: #111827;\n}\n\n.react-flow__controls-button:hover {\n  background: #f9fafb;\n}\n\n.react-flow__minimap {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);\n}\n\n.react-flow__node.selected > div {\n  outline: 2px solid rgba(99, 102, 241, 0.28);\n  outline-offset: 2px;\n}\n\n/* =========================================================\n   Sidebar (Typebot-like)\n   ========================================================= */\n.flowbuilder-sidebar {\n  /* Align full height with the flow canvas */\n  position: relative;\n  top: 0;\n  align-self: stretch;\n  height: 100%;\n  max-height: none;\n  overflow: auto;\n\n  width: 300px;\n  flex: 0 0 300px;\n\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid rgba(17, 24, 39, 0.08);\n  border-radius: 16px;\n  box-shadow: 0 14px 40px rgba(16, 24, 40, 0.10);\n\n  padding: 12px;\n\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto,\n    Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif;\n}\n\n.flowbuilder-sidebar::-webkit-scrollbar { width: 10px; }\n.flowbuilder-sidebar::-webkit-scrollbar-thumb {\n  background: rgba(15, 23, 42, 0.10);\n  border-radius: 999px;\n  border: 3px solid transparent;\n  background-clip: content-box;\n}\n.flowbuilder-sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(15, 23, 42, 0.18);\n  border: 3px solid transparent;\n  background-clip: content-box;\n}\n\n/* Top: Search + lock */\n.flowbuilder-sidebar__top{\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.flowbuilder-sidebar__search{\n  flex: 1;\n  height: 36px;\n  border-radius: 10px;\n  border: 1px solid rgba(17, 24, 39, 0.10);\n  background: #ffffff;\n  padding: 0 12px;\n  outline: none;\n  font-size: 13px;\n  color: #0f172a;\n}\n\n.flowbuilder-sidebar__search::placeholder{\n  color: rgba(15, 23, 42, 0.45);\n}\n\n.flowbuilder-sidebar__search:focus{\n  border-color: rgba(99, 102, 241, 0.35);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);\n}\n\n.flowbuilder-sidebar__lock{\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  border: 1px solid rgba(17, 24, 39, 0.10);\n  background: #ffffff;\n  color: rgba(15, 23, 42, 0.55);\n  cursor: not-allowed;\n}\n\n/* Sections */\n.flowbuilder-sidebar__section{\n  margin-bottom: 12px;\n}\n\n.flowbuilder-sidebar__title {\n  font-size: 12px;\n  font-weight: 600; /* lighter than before */\n  letter-spacing: 0.02em;\n  color: rgba(15, 23, 42, 0.55);\n  margin: 6px 6px 8px;\n}\n\n/* Grid of chips (Typebot-like) */\n.flowbuilder-sidebar__grid{\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  padding: 0 2px;\n}\n\n.flowbuilder-sidebar__chip{\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  height: 38px;\n  padding: 0 10px;\n\n  border-radius: 12px;\n  background: #ffffff;\n  border: 1px solid rgba(17, 24, 39, 0.10);\n\n  color: #0f172a;\n  cursor: pointer;\n  text-align: left;\n\n  transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease;\n}\n\n.flowbuilder-sidebar__chip:hover{\n  transform: translateY(-1px);\n  box-shadow: 0 10px 24px rgba(16, 24, 40, 0.10);\n  border-color: rgba(99, 102, 241, 0.28);\n}\n\n.flowbuilder-sidebar__chip:disabled{\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.flowbuilder-sidebar__chipIcon{\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n}\n\n.flowbuilder-sidebar__chipLabel{\n  font-size: 13px;\n  font-weight: 500; /* no bold */\n  line-height: 1;\n  color: rgba(15, 23, 42, 0.85);\n}\n\n/* Hide on small screens */\n@media (max-width: 980px) {\n  .flowbuilder-sidebar {\n    display: none;\n  }\n}\n\n/* =========================================================\n   Nodes (Premium) - used by message/menu/openai nodes\n   ========================================================= */\n.fb-node{\n  width: 250px;\n  position: relative;\n\n  background: rgba(255,255,255,0.96);\n  border: 1px solid rgba(17, 24, 39, 0.10);\n  border-radius: 16px;\n  box-shadow: 0 12px 30px rgba(16, 24, 40, 0.10);\n\n  padding: 12px;\n  transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease;\n\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto,\n    Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif;\n}\n\n.fb-node:hover{\n  transform: translateY(-1px);\n  box-shadow: 0 18px 46px rgba(16, 24, 40, 0.14);\n  border-color: rgba(99, 102, 241, 0.28);\n}\n\n.react-flow__node.selected .fb-node{\n  outline: 2px solid rgba(99, 102, 241, 0.28);\n  outline-offset: 2px;\n}\n\n.fb-node__header{\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-right: 56px;\n  margin-bottom: 8px;\n}\n\n.fb-node__chip{\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  border-radius: 999px;\n\n  background: rgba(99, 102, 241, 0.10);\n  border: 1px solid rgba(99, 102, 241, 0.18);\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 600; /* lighter */\n}\n\n.fb-node__body{\n  color: rgba(15, 23, 42, 0.75);\n  font-size: 12.5px;\n  line-height: 1.35;\n  padding-right: 6px;\n}\n\n/* Actions (top-right) */\n.fb-node__actions{\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  display: flex;\n  gap: 6px;\n}\n\n.fb-iconbtn{\n  width: 30px;\n  height: 30px;\n  border-radius: 10px;\n  border: 1px solid rgba(17, 24, 39, 0.08);\n  background: rgba(255,255,255,0.92);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: rgba(15, 23, 42, 0.55);\n  transition: background 120ms ease, transform 120ms ease, color 120ms ease,\n    border-color 120ms ease;\n}\n\n.fb-iconbtn:hover{\n  background: #ffffff;\n  color: rgba(15, 23, 42, 0.80);\n  border-color: rgba(99, 102, 241, 0.22);\n  transform: translateY(-1px);\n}\n\n/* Handles */\n.fb-handle{\n  width: 18px !important;\n  height: 18px !important;\n  border-radius: 999px !important;\n  background: #6366F1 !important;\n  border: 2px solid #ffffff !important;\n  box-shadow: 0 10px 22px rgba(99, 102, 241, 0.28);\n  cursor: pointer;\n}\n\n.fb-handle__arrow{\n  color: #ffffff;\n  width: 10px;\n  height: 10px;\n  margin-left: 4px;\n  margin-bottom: 1px;\n  pointer-events: none;\n}\n\n\n/* =========================================================\n   Workspace alignment (Sidebar + Canvas)\n   ========================================================= */\n.fb-workspace{\n  align-items: stretch;\n  gap: 14px;\n}\n\n/* Ensure canvas and sidebar share the same vertical span */\n.flow-canvas-container{\n  border-radius: 16px;\n  border: 1px solid rgba(17, 24, 39, 0.06);\n  box-shadow: 0 14px 40px rgba(16, 24, 40, 0.06);\n  overflow: hidden;\n}\n\n/* =========================================================\n   Header polish (Title + Buttons)\n   ========================================================= */\n.fb-headerbar{\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 18px;\n}\n\n.fb-header-left{\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.fb-header-left > *:first-child{\n  /* Title component */\n  margin: 0;\n}\n\n.fb-header-subtitle{\n  font-size: 12.5px;\n  font-weight: 400;\n  color: rgba(15, 23, 42, 0.62);\n}\n\n.fb-header-actions{\n  display: flex;\n  gap: 10px;\n}\n\n/* Buttons (Material-UI v4) */\n.fb-header-btn{\n  border-radius: 12px !important;\n  padding: 8px 14px !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  letter-spacing: 0 !important;\n  box-shadow: 0 10px 22px rgba(16, 24, 40, 0.10) !important;\n  transition: transform 120ms ease, box-shadow 120ms ease, filter 120ms ease !important;\n}\n\n.fb-header-btn:hover{\n  transform: translateY(-1px);\n  box-shadow: 0 14px 30px rgba(16, 24, 40, 0.14) !important;\n  filter: brightness(1.02);\n}\n\n/* Optional: color accents without changing your theme primary */\n.fb-btn-import{ }\n.fb-btn-export{ }\n.fb-btn-save{ }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
